import React from 'react'
import { useTranslation } from 'react-i18next'
import { ICellRendererParams } from 'ag-grid-enterprise'
import { EnhancedStatementRow } from '../../../utils/dataEnhancement'
import { StatementColumn } from '../../../types'
import { extractDataValue, isCellModified } from '../../../../../shared/utils/balanceRegistry'
import { DualValueCell } from './DualValueCell'
import ValueCellRenderer from './ValueCellRenderer'
import { statementCalculatedValueFormatter } from '../../../utils/columnUtils'

export interface DualValueCellRendererParams extends ICellRendererParams<EnhancedStatementRow> {
  hasComments: boolean
}

export const DualValueCellRenderer: React.FC<DualValueCellRendererParams> = params => {
  const { t } = useTranslation()
  const { colDef, data, value, valueFormatted, context: gridContext } = params

  // Extract column context to get data source info
  const columnContext = colDef?.context
  const columnData = columnContext?.column as StatementColumn | undefined

  if (!columnData) return null

  const calculatedValue = extractDataValue(data, columnData)
  const formattedCalculated =
    calculatedValue === undefined || calculatedValue === null
      ? ''
      : statementCalculatedValueFormatter(calculatedValue, gridContext?.numberFormat)

  // Check if value is edited (has value in newBudgets)
  const isEdited = isCellModified(data, columnData, 'newBudgets')

  // DualValueCellRenderer is now only used when showing both calculated and input values
  return (
    <DualValueCell
      calculatedContent={<ValueCellRenderer {...params} value={calculatedValue} valueFormatted={formattedCalculated} />}
      inputContent={<ValueCellRenderer {...params} value={value} valueFormatted={valueFormatted} hasComments={false} />}
      calculatedTitle={t('financialStatementsPage:calculated')}
      inputTitle={t('financialStatementsPage:input')}
      isEdited={isEdited}
    />
  )
}
